"use client";

import React from "react";
import { COLOR_THEMES } from "@/utils/colorThemes";
import { StatCardProps } from "@/app/@types";

export const StatCard: React.FC<StatCardProps> = ({
    value,
    label,
    color,
    className = "",
  }) => {
    const theme = COLOR_THEMES[color];

    return (
      <div
        className={`shrink-0 rounded-lg px-3 py-2 text-center bg-white/5 border border-white/10 ${className}`}
      >
        <div className={`text-xs font-black ${theme.textColor}`}>
          {value}
        </div>
        <div className="text-xs text-gray-400 font-semibold uppercase tracking-wide">
          {label}
        </div>
      </div>
    );
  };
